
/* DISABLED - Using Salesforce form now
(function($) {
	formHelper.addRule({
		form: '.form-contact-us',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);
*/

// Validate g-recaptcha
jQuery(function initGRecaptchaForm($) {

	$('#form-contact-us').each(function(index, el) {

		var $container = $(this);
		var $submitBtn = $container.find('.btn-submit');

		$submitBtn.click(function() {

			var fieldCheck  = true;
			var submitCheck = true;

			$('.js-fh-error-missing-fields-error').css('display','none');
			$('.js-fh-error-grecaptcha-error').css('display','none');

			$container.find('.form-control').each(function() {
				
				if ( $(this).val() === '' ) {
					$('.js-fh-error-missing-fields-error').css('display','block');
					fieldCheck = false;		
				}
			});

			if (fieldCheck) {

				var response = grecaptcha.getResponse();

				$.ajax({
					method: "POST",
					url: "/h/site/VerifyReCaptchaResponse",
					async: false, // necessary to ensure the AJAX completes (potentially setting 'submitCheck') before submitting the form to salesforce
					data: { reCaptchaResponse: response }
				})
				.done(function( data ) {
					
					var dataJSON = JSON.parse(data);

					if (dataJSON !== '') {

						if (dataJSON.type === 'failure') {
							 $('.js-fh-error-grecaptcha-error').css('display','block');
							 submitCheck = false;
						}
					}
				});

				if (submitCheck) {
					return true;
				}
				else {
					return false;
				}
			}
			else {
				return false;
			}
		});
	});
});